import { localStoragePersister } from "@app/app";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const useLocalCacheClear = () => {
	const queryClient = useQueryClient();

	const clearLocalCacheasync = useCallback(
		async (withReload: boolean) => {
			// Set a flag to skip cache restoration on next load
			localStorage.setItem("skip-cache-restore", "true");

			// Use the persister to remove the client cache
			await localStoragePersister.removeClient();

			// Clear the in-memory cache
			queryClient.removeQueries();
			queryClient.clear();

			// Manually remove the cache key
			const cacheKey = "REACT_QUERY_OFFLINE_CACHE";
			localStorage.removeItem(cacheKey);

			// Force reload to start fresh
			if (withReload) {
				alert("Local cache cleared successfully! Page will reload.");
				window.location.reload();
			}
		},
		[queryClient],
	);

	return clearLocalCacheasync;
};
